import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import App from './App';
import Settings from './services/settings.service';
import { initializeApp } from 'firebase/app';
import { analytics, performance } from 'firebase';

// firebase analytics for KW
if (Settings.get("version") === "_kuwait" && Settings?.firebase_analytics_configs) {
    const app = initializeApp(Settings.firebase_analytics_configs);
    analytics(app);
    performance(app);
}
ReactDOM.render(<App />, document.getElementById('root'));